<template>
  <section class="custom-dashboard">
    <dashboard-header @refresh="refresh" />
    <div v-show="isShow" class="custom-download">
      <button class="btn btn-link" @click="download">download</button>
    </div>
    <div v-show="isChecked" class="custom-message">
      <button
        class="btn btn-link custom-action-button"
        title="send messages"
        @click="sendMessage()"
      >
        <i class="fas fa-envelope custom-actions"></i>
      </button>
    </div>
    <div v-if="isShow">
      <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
      <div class="row p-3" v-if="currentTab === 'Activity'">
        <span>% progress</span>
        <analyze-activity
          ref="activity"
          @memberClick="memberClick"
          @showChart="showChart"
          @checked="checked"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Body Fat'">
        <analyze-bodyfat
          ref="bodyfat"
          @memberClick="memberClick"
          @checked="checked"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Body Weight'">
        <analyze-bodyweight
          ref="bodyweight"
          @memberClick="memberClick"
          @checked="checked"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Nutrition'">
        <span># meals (% progress)</span>
        <analyze-nutrition
          ref="nutrition"
          @memberClick="memberClick"
          @checked="checked"
        />
      </div>
      <div class="row p-3" v-if="isComponent">
        <analyze-dashboard
          ref="dashboardComponent"
          :componentName="currentTab"
          @checked="checked"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Challenge'">
        <span>% progress</span>
        <analyze-challenge
          ref="challenge"
          @memberClick="memberClick"
          @showChart="showChart"
          @checked="checked"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Membership'">
        <analyze-membership ref="membership" />
      </div>
    </div>
    <client-dialog :show="actionMember" @close="closeDialogs" />
    <chart-dialog :show="actionChart" @close="closeDialogs" />
    <send-message :show="actionMessage" @close="closeDialogs" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZTabs from '@/Components/ZElements/Tabs'
import DashboardHeader from './dashboard-header'
import AnalyzeActivity from './analyze/analyze-activity'
import AnalyzeBodyfat from './analyze/analyze-bodyfat'
import AnalyzeBodyweight from './analyze/analyze-bodyweight'
import AnalyzeChallenge from './analyze/analyze-challenge'
import AnalyzeMembership from './analyze/analyze-membership'
import AnalyzeNutrition from './analyze/analyze-nutrition'
import AnalyzeDashboard from './analyze/analyze-dashboard'
import ClientDialog from '@/Components/UserCardio/client/client-dialog'
import ChartDialog from './forms/chart-dialog'
import SendMessage from '@/Components/UserCardio/actions/send-message.vue'
export default {
  name: 'reporting-dashboard',
  components: {
    ZTabs,
    DashboardHeader,
    AnalyzeActivity,
    AnalyzeBodyfat,
    AnalyzeBodyweight,
    AnalyzeChallenge,
    AnalyzeMembership,
    AnalyzeNutrition,
    AnalyzeDashboard,
    ClientDialog,
    ChartDialog,
    SendMessage,
  },
  data() {
    return {
      isShow: false,
      isChecked: false,
      currentTab: 'Activity',
      actionMember: null,
      actionChart: null,
      actionMessage: null,
      isComponent: false,
    }
  },
  async mounted() {
    await this.init()
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('dashboardComponents', ['dashboardComponents']),
    ...mapGetters('reporting', ['members']),
    tabs() {
      let _tabs = ['Activity', 'Body Fat', 'Body Weight', 'Nutrition']
      if (this.components) {
        this.components.forEach((element) => {
          _tabs.push(element)
        })
      }
      _tabs.push('Challenge')
      _tabs.push('Membership')
      return _tabs
    },
    components() {
      let _data = []
      if (this.dashboardComponents) {
        this.dashboardComponents.forEach((element) => {
          _data.push(element.name)
        })
      }
      return _data
    },
  },
  methods: {
    ...mapActions('usercardio', ['getMember', 'setMemberIdsDirect']),
    ...mapActions('global', ['setLoading']),
    ...mapActions('reporting', ['resetData', 'setChecked']),
    ...mapActions('messages', ['setRecipients']),
    ...mapActions('dashboardComponents', ['getComponents']),
    ...mapActions('coaching', [
      'getWallMessages',
      'resetWallMessages',
      'resetWallMessage',
      'getMergeTags',
      'setWorkingText',
    ]),
    async init() {
      this.isChecked = false
      this.isComponent = false
      this.resetData({ name: 'all' })
      // get Custom Dashboard info
      await this.getComponents({
        page: 1,
        pageSize: 9999,
        sortBy: 'name',
        orderBy: 'asc',
        search: '',
        orgId: this.examineOrganization.id,
      })
    },
    showTab(value) {
      this.currentTab = value
      console.log('Show Tab (Reporting):', value)
      this.isComponent = this.components.includes(value)
      if (this.isComponent) {
        if (this.$refs.dashboardComponent) {
          this.$refs.dashboardComponent.reload(value)
        }
      }
    },
    checked(value) {
      this.isChecked = value
    },
    closeDialogs() {
      this.actionMember = null
      this.actionChart = null
      if (this.actionMessage !== null) {
        this.setChecked({
          area: 'activity',
          action: 'all',
          checked: false,
        })
      }
      this.actionMessage = null
    },
    async memberClick(id) {
      this.closeDialogs()
      this.setLoading(true)
      let date = moment().startOf('week').add(1, 'days').format('YYYY-MM-DD')
      await this.getMember({
        id: id,
        date: date,
      })
      this.resetWallMessages()
      let data = {
        id: id,
        orgId: this.examineOrganization.id,
      }
      this.resetWallMessage(data)
      await this.getWallMessages(data)
      console.log('Showing Member', date)
      this.actionMember = {
        id: id,
        title: 'Client Profile',
        date: date,
      }
      this.setLoading(false)
    },
    refresh() {
      this.isShow = true
      if (this.$refs.activity) {
        this.$refs.activity.reload()
      }
      if (this.$refs.bodyfat) {
        this.$refs.bodyfat.reload()
      }
      if (this.$refs.bodyweight) {
        this.$refs.bodyweight.reload()
      }
      if (this.$refs.nutrition) {
        this.$refs.nutrition.reload()
      }
      if (this.$refs.challenge) {
        this.$refs.challenge.reload()
      }
      if (this.$refs.membership) {
        this.$refs.membership.reload()
      }
      if (this.$refs.dashboardComponent) {
        this.$refs.dashboardComponent.reload()
      }
    },
    download() {
      switch (this.currentTab) {
        case 'Activity':
          if (this.$refs.activity) {
            this.$refs.activity.download()
          }
          break
        case 'Body Fat':
          if (this.$refs.bodyfat) {
            this.$refs.bodyfat.download()
          }
          break
        case 'Body Weight':
          if (this.$refs.bodyweight) {
            this.$refs.bodyweight.download()
          }
          break
        case 'Nutrition':
          if (this.$refs.nutrition) {
            this.$refs.nutrition.download()
          }
          break
        case 'Challenge':
          if (this.$refs.challenge) {
            this.$refs.challenge.download()
          }
          break
        case 'Membership':
          if (this.$refs.membership) {
            this.$refs.membership.download()
          }
          break
        default:
          if (this.components.includes(this.currentTab)) {
            console.log('Download:', this.currentTab)
            if (this.$refs.dashboardComponent) {
              this.$refs.dashboardComponent.download(this.currentTab)
            }
          }
          break
      }
    },
    showChart(data) {
      this.closeDialogs()
      console.log('show chart', data)
      switch (this.currentTab) {
        case 'Activity':
          if (data.name === 'activity') {
            this.actionChart = data
          }
          break
        case 'Body Fat':
          if (data.name === 'bodyfat') {
          }
          break
        case 'Body Weight':
          if (data.name === 'bodyweight') {
          }
          break
        case 'Nutrition':
          if (data.name === 'nutrition') {
          }
          break
        case 'Challenge':
          if (data.name === 'challenge') {
            this.actionChart = data
          }
          break
        case 'Membership':
          if (data.name === 'membership') {
          }
          break
      }
    },
    prepRecipients() {
      // set the recipients (used for email/notifications)
      let recipients = []
      let members = []
      this.members.forEach((element) => {
        if (element.checked) {
          recipients.push({
            id: element.user_id,
            value: element.name,
            label: element.name,
          })
          members.push({
            id: element.user_id,
            user_id: element.user_id,
            FirstName: element.firstname,
            LastName: element.lastname,
          })
        }
      })
      this.setRecipients({
        source: 0,
        recipients: recipients,
      })
      this.setMemberIdsDirect(members)
    },
    async sendMessage() {
      this.setLoading(true)
      this.closeDialogs()
      await this.getMergeTags()
      this.prepRecipients()
      this.setWorkingText(null)
      let data = {
        orgid: this.examineOrganization.id,
        id: null,
        type: 'notification',
      }
      this.actionMessage = data
      this.setLoading(false)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-dashboard {
  position: relative;
}
.custom-download {
  position: absolute;
  right: 0;
  width: 150px;
  cursor: pointer;
  z-index: 10;
}
.custom-message {
  position: absolute;
  right: 0;
  width: 200px;
  cursor: pointer;
  z-index: 10;
}
.custom-actions {
  font-size: 1.5em;
}
.custom-action-button:focus {
  box-shadow: none !important;
}
</style>
